import './lib/polyfills'
import Carousel from './components/carousel'
import { ieInfo } from './lib/iexplorer'
import { initHeader } from './components/header'
import { initEventsTimeline } from './components/website_type_events'
import { initGallery } from './components/website_type_gallery'
import { initTwitter } from './components/twitter'
import { initMember } from './components/member'
import { setCookie } from './lib/cookies'

const isMobile = () => innerWidth <= 1024

// Entry.
addEventListener('DOMContentLoaded', () => {
	// iOS Specific
	if (/(iPod|iPhone|iPad|iOS)/gi.test(navigator.userAgent)) {
		document.body.classList.add("ios")
	}
	if (/(Android|iPod|iPhone|iPad|iOS)/gi.test(navigator.userAgent)) {
		document.body.classList.add('mobile')
	}
	
	if (ieInfo && ieInfo.version == 11) {
		document.body.classList.add('ie11')
	} else if (ieInfo && ieInfo.version < 11) {
		document.body.classList.add('unsupported-ie')
		return
	}

	initAnimatable()
	initCookieBar()
	initHeader()

	initMember()

	initEventsTimeline()
	initGallery()

	Carousel.initializeAll()

	initTwitter('twitter-list', 'ISTORMnetwork')
})

/**
 * Initializations.
 */

function initAnimatable() {
	const animatables = [...document.querySelectorAll('.animatable')]

	const onScroll = (event) => {
		const scrollY = window.scrollY || document.body.scrollTop || window.pageYOffset || 0
		const scrollEnd = scrollY + innerHeight

		for (const animatable of animatables) {
			const offsetTop = animatable.offsetTop + (innerHeight / 4)
			const offsetEnd = offsetTop + animatable.offsetHeight

			if (scrollEnd >= offsetTop && scrollY <= offsetEnd) {
				animatable.classList.add('visible')
			}
		}
	}

	addEventListener('scroll', onScroll)
}

function initCookieBar() {
	const cookieBar = document.querySelector('#cookie-bar')

	if (!cookieBar) {
		return
	}

	const acceptButton = cookieBar.querySelector('#cookie-accept')
	const declineButton = cookieBar.querySelector('#cookie-denied')

	const confirm = (enabled = true) => setCookie('c_enabled', enabled.toString(), 30)

	acceptButton.addEventListener('click', () => {
		cookieBar.parentNode.removeChild(cookieBar)
		confirm(true)
	})

	declineButton.addEventListener('click', () => {
		cookieBar.parentNode.removeChild(cookieBar)
		confirm(false)
	})
}